module.exports = __webpack_public_path__ + "img/ic_pin_store.1d88e285.png";